module.exports = __webpack_public_path__ + "static/media/hero-m.2e41125f.jpg";